module.exports = __webpack_public_path__ + "files/5f226adb1f4d0f51e1dd8a258a28ca8a.png";